import AuthGuard from "@/middleware/auth";

export default [
  { path: "/flights/inventory", name: "FlightsInventory", component: () => import("@/views/flights/inventory"), beforeEach: AuthGuard },
  { path: "/flights/bookings", name: "FlightsBookings", component: () => import("@/views/flights/bookings"), beforeEach: AuthGuard },
  { path: "/flights/reports", name: "FlightsReports", component: () => import("@/views/flights/reports"), beforeEach: AuthGuard },
  {
    path: "/flights/inventory/details/:inventory_id",
    name: "FlightsInventoryDetails",
    component: () => import("@/views/flights/inventory/details"),
    beforeEach: AuthGuard
  }
];
